module.exports = __webpack_public_path__ + "img/choose-nummber.72ef5e8c.png";